import { render, staticRenderFns } from "./PersonalNotesList.vue?vue&type=template&id=170d10ac&scoped=true&"
import script from "./PersonalNotesList.vue?vue&type=script&lang=js&"
export * from "./PersonalNotesList.vue?vue&type=script&lang=js&"
import style0 from "./PersonalNotesList.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PersonalNotesList.vue?vue&type=style&index=1&id=170d10ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170d10ac",
  null
  
)

export default component.exports